import lf from 'lovefield'

export function const_sols (schemaBuilder) {
  schemaBuilder.createTable('const_sols')
  	  .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('equivalencegtr', lf.Type.STRING)
      .addColumn('coefremplissage', lf.Type.STRING)
      .addColumn('massevolumique', lf.Type.STRING)
      .addColumn('coeffoisonnement', lf.Type.STRING)
      .addNullable(['coeffoisonnement']);
      
}

/*
CREATE TABLE IF NOT EXISTS `const-sols` (
  `code` varchar(4) NOT NULL,
  `nom` varchar(50) NOT NULL,
  `equivalencegtr` varchar(10) NOT NULL
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constSols.schema.js